import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.title,
    footer: null,
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_list, {
        "item-layout": "horizontal",
        "data-source": _ctx.comments
      }, {
        renderItem: _withCtx(({ item }) => [
          _createVNode(_component_a_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_list_item_meta, {
                description: item.comment
              }, {
                title: _withCtx(() => [
                  _createElementVNode("a", null, _toDisplayString(item.username), 1)
                ]),
                _: 2
              }, 1032, ["description"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}